module.exports = __webpack_public_path__ + "static/img/bg-img.dec5bc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-img.jpg
// module id = gf20
// module chunks = 1